import type { VariantProps } from "tailwind-variants";

import type { AcuityStatus } from "@/core/types";
import { Badge2 } from "@/ui2/atoms/Badge";
import type { badgeStyles } from "@/ui2/atoms/Badge";
import { cn } from "@/lib/helpers/cn";

type AcuityStatusBadgeProps = {
  className?: string;
  status: AcuityStatus;
};

export function AcuityStatusBadge({ className, status }: AcuityStatusBadgeProps) {
  const { appearance, label, variant } = ACUITY_STATUS_TO_BADGE[status] || {};

  return (
    <Badge2
      appearance={appearance}
      className={cn("tw:normal-case", className)}
      size="sm"
      variant={variant}
    >
      {label}
    </Badge2>
  );
}

type BadgeVariant = Pick<VariantProps<typeof badgeStyles>, "appearance" | "variant">;

const ACUITY_STATUS_TO_BADGE: Record<AcuityStatus, { label: string } & BadgeVariant> = {
  APPROVED: {
    appearance: "outline",
    label: "Approved",
    variant: "success",
  },
  PENDING: {
    appearance: "outline",
    label: "Pending",
    variant: "neutral",
  },
  REJECTED: {
    appearance: "outline",
    label: "Rejected",
    variant: "error",
  },
  SYSTEM_ASSIGNED: {
    label: "System Change",
    variant: "neutral",
  },
} as const;
